export default __webpack_public_path__ + "static/media/bottom-green-pattern.133a91f3.svg";